<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
  },
  data() {
    return {

    }
  }
}
</script>

<template>
  <div :class="$style.baseList" class="h-100">
    <span class="baseList__icon" v-html="icon"></span>
    <h3 class="baseList__title" v-html="title"></h3>
    <p class="baseList__content">{{content}}</p>
  </div>
</template>
<style lang="scss" module>
  .baseList {
    position: relative;
    background-color: #FFFFFF;
    box-shadow:  0px 3px 24px rgba(98, 90, 84, 0.1);
    border-radius: 10px;
    padding: 64px 27px 30px 27px;
    text-align: center;
    z-index: 3;
    &:hover {
      box-shadow: 0px 8px 28px rgba(98, 90, 84, 0.2);
    }
    @include max-sm {
      padding: 38px 16px 20px 16px;
    }
    :global {
      .baseList {
        &__title {
          font-size: 18px;
          font-weight: 600;
          @include max-sm {
            font-size: 13.5px;
          }
        }
        &__icon {
          position: absolute;
          top: -32px;
          left: 50%;
          transform: translateX(-50%);
          background-image: url('~@assets/images/home/section3-blob.svg');
          background-repeat: no-repeat;
          background-size: cover;
          height: 67.63px;
          width: 80px;
          color: $color-primary;
          font-size: 35px;
          line-height: 67.63px;
          display: block;
          text-align: center;
          @include max-sm {
            height: 50px;
            width: 60px;
            line-height: 50px;
            font-size: 26px;
            top: -22px;
          }
        }
        &__content {
          font-size: 14px;
          color: $color-text-3;
          line-height: 1.75;
          margin-bottom: 0;
          margin-top: 10px;
          @include max-sm {
            font-size: 10.5px;
          }
        }
      }
    }
  }
</style>